import trackEvent from '@/common/js/track'
// 优惠券中心页面曝光
export function couponCenterSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_center_sw',
    eventLabel: '优惠券中心页面曝光',
    attrs: {...options}
  })
}
// 兑换券入口曝光
export function voucherEntranceSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_voucher_entrance_sw',
    eventLabel: '兑换券入口曝光',
    attrs: {...options}
  })
}
// 兑换券点击
export function voucherEntranceCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_voucher_entrance_ck',
    eventLabel: '兑换券点击',
    attrs: {...options}
  })
}
// 兑换券结果
export function voucherExchangeCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_voucher_exchange_ck',
    eventLabel: '兑换券结果',
    attrs: {...options}
  })
}
// 优惠券模块曝光
export function couponModelSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_model_sw',
    eventLabel: '优惠券模块曝光',
    attrs: {...options}
  })
}
// 账户优惠券点击
export function couponModelCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_model_ck',
    eventLabel: '账户优惠券点击',
    attrs: {...options}
  })
}
// 点击查看更多优惠券
export function couponMoreCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_more_ck',
    eventLabel: '点击查看更多优惠券',
    attrs: {...options}
  })
}
// 券包购买卡片曝光
export function couponBuyCommonSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_buy_common_sw',
    eventLabel: '券包购买卡片曝光',
    attrs: {...options}
  })
}
// 券包购买卡片“支付”按钮点击
export function couponPayCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_pay_ck',
    eventLabel: '券包购买卡片“支付”按钮点击',
    attrs: {...options}
  })
}// 券包卡片详情点击
export function couponViewCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_view_ck',
    eventLabel: '券包卡片详情点击',
    attrs: {...options}
  })
}
// 券包购买卡片弹窗曝光
export function couponBuyPopupSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_buy_popup_sw',
    eventLabel: '券包购买卡片弹窗曝光',
    attrs: {...options}
  })
}
// 券包购买弹窗支付方式点击
export function couponPaymethodPopupCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_paymethod_popup_ck',
    eventLabel: '券包购买弹窗支付方式点击',
    attrs: {...options}
  })
}
// 券包购买弹窗pay点击
export function couponPayPopupCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_pay_popup_ck',
    eventLabel: '券包购买弹窗pay点击',
    attrs: {...options}
  })
}
// 券包购买支付结果
export function couponPayResultCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_pay_result_ck',
    eventLabel: '券包购买支付结果',
    attrs: {...options}
  })
}
// CGC卡片曝光
export function cgcCardCommonSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_card_common_sw',
    eventLabel: 'CGC卡片曝光',
    attrs: {...options}
  })
}
// CGC卡片“view”点击
export function cgcCardViewCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_card_view_ck',
    eventLabel: 'CGC卡片“view”点击',
    attrs: {...options}
  })
}
// CGC卡片邀请按钮点击
export function cgcCardInviteCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_card_invite_ck',
    eventLabel: 'CGC卡片邀请按钮点击',
    attrs: {...options}
  })
}
// CGC弹窗曝光
export function landingCgcPopupSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_popup_sw',
    eventLabel: 'CGC弹窗曝光',
    attrs: {...options}
  })
}
// CGC弹窗复制按钮点击
export function cgcCopyPopupCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_copy_popup_ck',
    eventLabel: 'CGC弹窗复制按钮点击',
    attrs: {...options}
  })
}
// CGC弹窗分享方式点击
export function cgcSharePopupCk (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_cgc_share_popup_ck',
    eventLabel: 'CGC弹窗分享方式点击',
    attrs: {...options}
  })
}

// 优惠券中心-商家实券曝光
export function conpouRealexposureSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_realexposure_sw',
    eventLabel: '优惠券中心-商家实券曝光',
    attrs: {...options}
  })
}

// 券包详情页曝光
export function couponPackageCommonSw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_common_sw',
    eventLabel: '券包详情页曝光',
    attrs: {...options}
  })
}

// 券包详情页“支付”按钮点击
export function couponPackagePaySw (options) {
  trackEvent({
    eventId: 'sailing_c_x_landing_coupon_package_pay_ck',
    eventLabel: '券包详情页“支付”按钮点击',
    attrs: {...options}
  })
}
